import type { AstroGlobal } from "astro";
import { resolveAcceptLanguage } from "resolve-accept-language";
import type { TupleToUnion } from "type-fest";

export const locales = [
  "en-US",
  "es-ES",
  "fa-IR",
  "fr-FR",
  "hi-IN",
  "ja-JP",
  "ko-KR",
  "pt-BR",
  "uk-UA",
  "zh-CN",
] as const;

export type Locale = TupleToUnion<typeof locales>;

export const getLocale = (Astro: AstroGlobal) => {
  const locale = resolveAcceptLanguage(
    Astro.cookies.get("locale")?.value ?? "",
    locales,
    resolveAcceptLanguage(
      Astro.request.headers.get("Accept-Language") ?? "",
      locales,
      "en-US",
    ),
  );

  return locale;
};
